import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SetModuleLoading } from '@store/module-load.action';

export interface ModuleLoadStateModel {
  loading: boolean;
}

@State<ModuleLoadStateModel>({
  name: 'moduleLoadingState'
})
@Injectable()
export class ModuleLoadState {
  @Selector()
  static getModuleLoadingState(state: ModuleLoadStateModel): boolean {
    return state.loading;
  }

  @Action(SetModuleLoading)
  setLoadingState(
    { patchState }: StateContext<ModuleLoadStateModel>,
    { payload }: SetModuleLoading
  ): void {
    patchState({
      loading: payload
    });
  }
}
